import { OrderDetailContent } from '@euler/app/flows/order/components/OrderDetailContent';
import { OrderDetailProvider } from '@euler/app/flows/order/components/OrderDetailProvider';
import { useOrderDetailPropsFromTaskContext } from '@euler/app/flows/task/functions/useOrderDetailPropsFromTaskContext';
import { Aside } from '@euler/components/Aside';
import { adaptiveWrapperOptions } from '@euler/functions/navigationOptionsBuilder';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { CardStyleInterpolators } from '@react-navigation/stack';
import { ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const TaskOrderDetailPage = wrapNavigatorScreen(
  () => {
    const { bottom } = useSafeAreaInsets();
    const orderDetailProps = useOrderDetailPropsFromTaskContext();
    const { statusBarHeight } = useSystemMetrics();

    return (
      <OrderDetailProvider props={orderDetailProps}>
        <Aside dismissible>
          <ScrollView
            contentContainerStyle={{
              paddingTop: statusBarHeight,
              paddingBottom: bottom,
            }}
          >
            <OrderDetailContent />
          </ScrollView>
        </Aside>
      </OrderDetailProvider>
    );
  },
  adaptiveWrapperOptions({
    headerStatusBarHeight: undefined,
    cardStyleInterpolator: CardStyleInterpolators.forScaleFromCenterAndroid,
  }),
);
